import Vue from 'vue';
import nullData from "./nullData";
import error from "./error";
import loading from "./loading"

let loadingTimer;

const bitMap = {
    inserted(el, binding) {
        let getResult = binding.value;
        el.classList.add('position')
        // el.style.position = "relative";
        setBitMapByGetResult(el, getResult)
    },
    update(el, binding) {
        // console.log(el)
        el.classList.add('position')
        clearTimeout(loadingTimer);
        let getResult = binding.value;
        if (binding.value != binding.oldValue) {
            if (el.instance && el.instance.$el) {
                try {
                    el.removeChild(el.instance.$el)
                } catch (e) {

                }

            }
            setBitMapByGetResult(el, getResult)
        }
    }
}

function setBitMapByGetResult(el, getResult) {
    if (getResult === 'nullData') {
        const nullDataCtor = Vue.extend(nullData);
        el.instance = new nullDataCtor().$mount();
    } else if (getResult === 'error') {
        const errorCtor = Vue.extend(error);
        el.instance = new errorCtor().$mount();
    } else if (getResult === 'loading') {
        return loadingTimer = setTimeout(() => {
            // console.log('loading挂载的el',el)
            const loadingCtor = Vue.extend(loading);
            el.instance = new loadingCtor().$mount();
            el.appendChild(el.instance.$el)
        }, 400)
    } else if (getResult === 'success') {
        if (el.instance && el.instance.$el) {
            el.instance.$el = null
        }
        return el.classList.remove('position')
    }
    // console.log(el.instance.$el)
    el.appendChild(el.instance.$el)
}

export default bitMap 